import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { AboutEraman } from "./AboutEraman/AboutEraman";
import { EramanPrivilegeCard } from "./EramanPrivilegeCard/EramanPrivilegeCard";
import { TravellersInfo } from "./TravellersInfo/TravellersInfo";

export const Pages = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");

  useEffect(() => {
    if (approveId) {
      return;
    }

    const activeTab = query.get("activeTab");
    const subActiveTab = query.get("subActiveTab");
    const thirdChildActiveTab = query.get("thirdChildActiveTab");
    const fourthChildActiveTab = query.get("fourthChildActiveTab");
    if (!activeTab) {
      navigate(`/dedicated/eraman/pages?activeTab=aboutEraman&subActiveTab=aboutUs`, {
        replace: true,
      });
    } else {
      if (activeTab === "aboutEraman") {
        // Mapping subActiveTab to its default thirdChildActiveTab
        const defaultThirdSubActiveTabMap: Record<string, string> = {
          careers: "careersContent",
          awards: "awardsContent",
          contactUs: "contactDetails",
        };

        const defaultThirdSubActiveTab = defaultThirdSubActiveTabMap[subActiveTab] || "";

        navigate(
          `/dedicated/eraman/pages?activeTab=aboutEraman&subActiveTab=${subActiveTab ?? "aboutUs"}${
            defaultThirdSubActiveTab ? `&thirdChildActiveTab=${thirdChildActiveTab || defaultThirdSubActiveTab}` : ""
          }`,
          { replace: true }
        );
      }

      if (activeTab === "eramanPrivilegeCard") {
        navigate(
          `/dedicated/eraman/pages?activeTab=eramanPrivilegeCard&subActiveTab=${subActiveTab ?? "TermsAndConditions"}`,
          {
            replace: true,
          }
        );
      }
      if (activeTab === "travellersInfo") {
        let defaultThirdSubActiveTab: string | null = null;
        let defaultFourthChildActiveTab: string | null = null;

        switch (subActiveTab) {
          case "baggageGuide":
            defaultThirdSubActiveTab = "singleCabinLuggagePolicy";
            break;
          case "lagsAndRestrictedItems":
            defaultThirdSubActiveTab = "lags";
            break;
          default:
            defaultThirdSubActiveTab = "singleCabinLuggagePolicy";
            break;
        }

        switch (thirdChildActiveTab || defaultThirdSubActiveTab) {
          case "singleCabinLuggagePolicy":
            defaultFourthChildActiveTab = "singleCabinLuggagePolicyPageContent";
            break;
          case "guidelinesForCheckedinLuggage":
            defaultFourthChildActiveTab = "guidelinesForCheckedinLuggagePageContent";
            break;
          case "lags":
            defaultFourthChildActiveTab = "lagsPageContent";
            break;
          case "restrictedItems":
            defaultFourthChildActiveTab = "restrictedItemsCheckedInCabinRestrictionsContent";
            break;
        }
        navigate(
          `/dedicated/eraman/pages?activeTab=travellersInfo&subActiveTab=${subActiveTab ?? "baggageGuide"}${
            defaultThirdSubActiveTab ? `&thirdChildActiveTab=${thirdChildActiveTab || defaultThirdSubActiveTab}` : ""
          }${
            defaultFourthChildActiveTab
              ? `&fourthChildActiveTab=${fourthChildActiveTab || defaultFourthChildActiveTab}`
              : ""
          }`,
          { replace: true }
        );
      }
      if (activeTab === "contactCentre") {
        navigate(
          `/dedicated/eraman/pages?activeTab=contactCentre&subActiveTab=${subActiveTab ?? "footerContactInfo"}`,
          {
            replace: true,
          }
        );
      }
    }
  }, [query.get("activeTab"), query.get("subActiveTab"), query.get("thirdChildActiveTab")]);

  const items = [
    {
      label: "About Eraman",
      key: "aboutEraman",
      children: <AboutEraman />,
    },
    {
      label: "Eraman Privilege Card",
      key: "eramanPrivilegeCard",
      children: <EramanPrivilegeCard />,
    },
    {
      label: "Traveller's Info",
      key: "travellersInfo",
      children: <TravellersInfo />,
    },
    // {
    //   label: "Contact Centre",
    //   key: "contactCentre",
    //   children: <ContactCentre />,
    // },
  ];

  const handleProductManagement = (activeTab: any, thirdChildActiveTab: any) => {
    if (thirdChildActiveTab === "awardsList") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/pages/aboutEraman/awards/awardsList/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New Award
        </Button>
      );
    } else if (activeTab === "Faqs") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/pages/eramanPrivilegeCard/Faqs/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New FAQ
        </Button>
      );
    } else if (activeTab === "news") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/pages/aboutEraman/news/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New News
        </Button>
      );
    } else if (activeTab === "dutyFreeBuyingGuide") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/pages/travellersInfo/dutyFreeBuyingGuide/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New Duty Free Buying Guide
        </Button>
      );
    } else if (thirdChildActiveTab === "jobOpportunities") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/pages/aboutEraman/careers/jobOpportunities/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New Job Opportunities
        </Button>
      );
    }
  };

  return (
    <ContentWrapper
      title={"Pages"}
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handleProductManagement(query.get("subActiveTab"), query.get("thirdChildActiveTab"))}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
